import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-redeem-rewards-success-popup',
    templateUrl: './redeem-rewards-success-popup.component.html',
    styleUrls: ['./redeem-rewards-success-popup.component.scss'],
    standalone: false
})
export class RedeemRewardsSuccessPopupComponent implements OnInit {

  @Input() data: any = {};
  
  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  redeemPoints() {
    if (this.data.accountType === 'EMPLOYEE_REWARDS') {
      this.router.navigate(['/marketplace/dashboard'], { queryParams :  { program : 'employee_rewards' } });
    }
    else if (this.data.accountType === 'CHANNEL_INCENTIVE') {
      this.router.navigate(['/marketplace/dashboard'], { queryParams :  { program : 'channel_incentive' } });
    }
  }

}
